import { render } from "./MerchantCard.vue?vue&type=template&id=7b1e3c72&scoped=true&ts=true"
import script from "./MerchantCard.vue?vue&type=script&lang=ts"
export * from "./MerchantCard.vue?vue&type=script&lang=ts"

import "./MerchantCard.vue?vue&type=style&index=0&id=7b1e3c72&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bakery-platform/bakery-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b1e3c72"]])

export default __exports__